package xim.resource.table

val MountNameTable = StringTable(resourceName = "ROM/351/84.DAT")